export const roundUpTo2 = (value) => {
  return Math.round(value * 100) / 100;
};